import MotionCardToModal, { MotionCardToModalProps } from '@motion/CardToModal';

import {
  DashboardAircraftCard,
  DashboardAircraftData,
} from '../../mockData/dashboard';
import DashboardContentAircraftCard from './_aircraftCard';
import DashboardContentAircraftModalCard from './_aircraftModalCard';

interface Props {
  aircrafts: DashboardAircraftData;
}

const DashboardContentManufacturer: React.FC<Props> = ({ aircrafts }) => {
  const CSSBlock = 'home';
  const getContent = (index: string) => aircrafts.cards[index];

  const generateChartData = (card: DashboardAircraftCard) => {
    // Generates random chart data starting from a base price.
    function generateRandomChartData(basePrice: number) {
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const chartData: { month: string; value: number }[] = [];
      let previousValue = basePrice;
      for (const month of months) {
        const changeFactor = Math.random() * 0.4 - 0.2; // -20% to +20% change
        const newValue = Math.round(
          previousValue + previousValue * changeFactor
        );
        chartData.push({ month, value: newValue });
        previousValue = newValue;
      }
      return chartData;
    }

    // Assuming `card` may have a basePrice property; default to 30 if not provided.
    const basePrice = (card as any).basePrice || 30;
    const chartData = generateRandomChartData(basePrice);
    return chartData;
  };

  const mapToMotionCardModalItems = (
    cards: DashboardAircraftCard[]
  ): MotionCardToModalProps[] => {
    return cards.map((card, index) => {
      const chartData = generateChartData(card);
      const layoutID = `${card.make}-${card.model}-${index}`;
      return {
        layoutID,
        baseView: (
          <DashboardContentAircraftCard
            card={card}
            chartData={chartData}
            key={index}
          />
        ),
        modalView: (
          <DashboardContentAircraftModalCard
            card={card}
            chartData={chartData}
            key={index}
          />
        ),
      };
    });
  };

  return aircrafts.manufacturers.map((manufacturer, i) => {
    const items = mapToMotionCardModalItems(getContent(manufacturer.id));
    return (
      <div className={`${CSSBlock}__manufacturer`} key={manufacturer.id}>
        <h2 className="text-lg font-medium leading-none">
          {manufacturer.label}
        </h2>
        <div className={`${CSSBlock}__aircraft-grid`}>
          {items.map((item, j) => {
            return <MotionCardToModal {...item} key={j} />;
          })}
        </div>
        {i !== aircrafts.manufacturers.length - 1 && (
          <div className={`${CSSBlock}__separator`} />
        )}
      </div>
    );
  });
};

export default DashboardContentManufacturer;
